module.exports = __webpack_public_path__ + "static/img/file.c824b93d.jpeg";